<script setup>
defineOptions({
  name: 'ZeroEmissionDocumentContractSelectionModal',
})

/*
|--------------------------------------------------------------------------
| ZeroEmissionDocumentContractSelectionModal.vue
|--------------------------------------------------------------------------
| Selects the ZE contract first. The create form then determines the correct
| input path from the contract's stored accountability_type.
*/

import { computed, getCurrentInstance, ref } from 'vue'
import { router } from '@inertiajs/vue3'
import Modal from '@/components/Modal.vue'
import FormRichSelect from '@/components/Form/FormRichSelect.vue'

const instance = getCurrentInstance()
const route = instance?.appContext.config.globalProperties.route

const props = defineProps({
  modelValue: { type: [Boolean, String], default: false },
})

const emit = defineEmits(['update:modelValue', 'select', 'close'])

const show = computed({
  get: () => !!props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const selectedContract = ref(null)
const searchUrl = computed(() => route('ze-documents.data.contracts'))

function handleSelect() {
  if (!selectedContract.value) return

  const contractId = selectedContract.value

  emit('select', { contract_id: contractId })
  router.visit(route('ze-documents.create', { contract: contractId }))
  close()
}

function close() {
  show.value = false
  selectedContract.value = null
  emit('close')
}
</script>

<template>
  <Modal
    :show="show"
    title="Emissie invoeren"
    size="lg"
    theme="green"
    confirm-button-variant="green"
    confirm-button-text="Selecteren"
    :confirm-button-disabled="!selectedContract"
    :show-default-footer="true"
    :cancel-button-id="'input-zero-emission-document-modal-cancel'"
    :confirm-button-id="'input-zero-emission-document-modal-select'"
    @close="close"
    @cancel="close"
    @confirm="handleSelect"
  >
    <div class="zero-emission-document-selection-modal-content">
      <p class="modal-description">
        Selecteer een contract om een zero emissie in te voeren.
      </p>

      <div class="zero-emission-document-selection-field">
        <label for="input-zero-emission-document-contract-selection" class="form-label">
          Contract
        </label>
        <FormRichSelect
          id="input-zero-emission-document-contract-selection"
          v-model="selectedContract"
          :search-url="searchUrl"
          placeholder="Zoek op titel, klant of opdrachtnemer..."
          option-label="label"
          option-value="value"
          option-layout="card"
          class="wide-dropdown"
        />
      </div>
    </div>
  </Modal>
</template>
